var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMerged1Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6048_41302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 22.4986H7.8326V15.166H4.1696C2.1434 15.166 0.5 16.8094 0.5 18.8356",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8326 22.498H0.5V29.8306H4.1696C6.1958 29.8306 7.8392 28.1872 7.8392 26.161",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 44.5025H7.8326V37.1699H4.1696C2.1434 37.1699 0.5 38.8067 0.5 40.8329",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8326 44.502H0.5V51.8346H7.8326V44.502Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8326 51.834H0.5V59.1666H7.8326V51.834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83082 37.1693H15.1634V29.8301H11.4938C9.46762 29.8301 7.82422 31.4735 7.82422 33.4997",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1646 51.834H7.83203V59.1666H11.5016C13.5278 59.1666 15.1712 57.5232 15.1712 55.497",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1628 15.1646H22.4954V7.83203H18.8259C16.7997 7.83203 15.1562 9.47543 15.1562 11.5016",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4967 15.166H15.1641V22.4986H18.8337C20.8599 22.4986 22.5033 20.8552 22.5033 18.829",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4967 29.8301H15.1641V37.1627H22.4967V29.8301Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4967 37.1699H15.1641V44.5025H18.8337C20.8599 44.5025 22.5033 42.8591 22.5033 40.8329",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8314 0.5H26.1618C24.1356 0.5 22.4922 2.1434 22.4922 4.1696V7.8392H26.1618C28.188 7.8392 29.8314 6.1958 29.8314 4.1696",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4988 29.8306H29.8314V22.498H26.1618C24.1356 22.498 22.4922 24.1414 22.4922 26.1676",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4988 59.1666H29.8314V51.834H26.1618C24.1356 51.834 22.4922 53.4774 22.4922 55.5036",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8281 15.1646H37.1607V7.83203H33.4977C31.4715 7.83203 29.8281 9.47543 29.8281 11.5016",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1607 15.166H29.8281V22.4986H37.1607V15.166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1607 22.498H29.8281V29.8306H37.1607V22.498Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1607 51.834H29.8281V59.1666H37.1607V51.834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1607 59.168H29.8281V66.5006H37.1607V59.168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1707 7.8326H44.5033V0.5H40.8337C38.8075 0.5 37.1641 2.1434 37.1641 4.1696",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5045 7.83203H37.1719V15.1646H40.8415C42.8677 15.1646 44.5111 13.5212 44.5111 11.495",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5045 22.498H37.1719V29.8306H40.8415C42.8677 29.8306 44.5111 28.1872 44.5111 26.161",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1707 44.5025H44.5033V37.1699H40.8337C38.8075 37.1699 37.1641 38.8133 37.1641 40.8395",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5045 44.502H37.1719V51.8346H44.5045V44.502Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5045 59.168H37.1719V66.5006H44.5045V59.168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8326 0.5H44.5V7.8326H51.8326V0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5027 22.4986H51.8353V15.166H48.1657C46.1395 15.166 44.4961 16.8094 44.4961 18.8356",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8353 29.8301H48.1657C46.1395 29.8301 44.4961 31.4735 44.4961 33.4997V37.1693H48.1657C50.1919 37.1693 51.8353 35.5259 51.8353 33.4997",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8326 44.502H44.5V51.8346H48.1696C50.1958 51.8346 51.8392 50.1912 51.8392 48.165",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8326 59.168H44.5V66.5006H51.8326V59.168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1685 0.5H51.8359V7.8326H55.5055C57.5317 7.8326 59.1751 6.1892 59.1751 4.163",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1685 15.166H51.8359V22.4986H55.5055C57.5317 22.4986 59.1751 20.8552 59.1751 18.829",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8347 44.5025H59.1673V37.1699H55.4977C53.4715 37.1699 51.8281 38.8133 51.8281 40.8395",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8347 59.1666H59.1673V51.834H55.4977C53.4715 51.834 51.8281 53.4774 51.8281 55.5036",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1668 29.8306H66.4994V22.498H62.8298C60.8036 22.498 59.1602 24.1414 59.1602 26.1676",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5006 29.8301H59.168V37.1627H66.5006V29.8301Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5006 37.1699H59.168V44.5025H62.8376C64.8638 44.5025 66.5072 42.8591 66.5072 40.8329",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1685 59.168H51.8359V66.5006H55.5055C57.5317 66.5006 59.1751 64.8572 59.1751 62.831",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6048_41302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerged1Icon);
export default __webpack_public_path__ + "static/media/merged-1-icon.940ce2e2da8d4ba8d0f81bfd08cab81c.svg";
export { ForwardRef as ReactComponent };